import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import InputIcon from "@material-tailwind/react/InputIcon";
import DataTable from "react-data-table-component";
import { Button } from "@material-tailwind/react";

export default function CardTable({ dataTable, pending, usernameEvent, clearTargetTurnoverEvent, onChangeRowsPerPage }) {
  const columns = [
    {
      name: "Username",
      selector: (row) => row.username,
      sortable: true,
      width: "150px",
    },
    {
      name: "Target Amount",
      selector: (row) => <tt>{row.amount}</tt>,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      selector: (row) => <tt><Button color="green" value={row.username} onClick={clearTargetTurnoverEvent} >Clear</Button></tt>,
      sortable: true,
      center: true,
    },
  ];

  return (
    <>
      <Card>
        <h5>Advanced Search</h5>
        <CardBody>
          <div className="flex gap-4">
            <InputIcon
              type="text"
              color="lightBlue"
              size="sm"
              outline={true}
              placeholder="Username"
              iconName="search"
              onChange={usernameEvent}
            />
          </div>
        </CardBody>
      </Card>
      <Card className="mt-12">
        <CardHeader color="blueGray" contentPosition="left">
          <h2 className="text-white text-2xl">Player Target Turnover</h2>
        </CardHeader>
        <CardBody>
          <DataTable
            columns={columns}
            data={dataTable}
            progressPending={pending}
            onChangeRowsPerPage={onChangeRowsPerPage}
            paginationRowsPerPageOptions={[10, 50, 100, 500]}
            pagination
          />
        </CardBody>
      </Card>
    </>
  );
}
